<template>
  <div class="log-query">
     <NginxMonitor ref="NginxMonitor"></NginxMonitor>
     <Modal title="显示列" v-model="tableColModal">
      <Checkbox-group v-model="col">
        <Checkbox :label="item.key" v-for="item in tableColumnList" :key="item.key" v-if="item.key">{{ item.title }}</Checkbox>
      </Checkbox-group>
      <div slot="footer">
        <Button type="primary" :loading="saveShowColConfiging" style="margin-right: 8px" icon="md-checkmark" @click="saveShowColConfig">确认</Button>
        <Button @click="tableColModal = false">取消</Button>
      </div>
    </Modal>
    <Card style="margin-bottom:10px;">
     <Form ref="searchForm" inline :model="searchForm" :rules="ruleValidSearch">
      <Row>
          <!-- <FormItem label="索引名称" prop="index_name">
          <i-select v-model="searchForm.indexName"  style="width: 90%;" @on-change="onSelectIndex">
            <i-option v-for="item in indexList" :value="item" :key="item" :label="item"></i-option>
            </i-select>
          </FormItem> -->
          <FormItem label="时间" prop="logDate" :label-width="60" class="mob-w-100">
            <DatePicker type="daterange" :disabled="dateDisabled" placeholder="Select date and time"  format="yyyy-MM-dd" v-model="searchForm.logDate"></DatePicker>
          </FormItem>
           <!-- <form-item>
              <radio-group v-model="searchForm.selectTime" type="button"  @on-change="lastTimeChange">
                <radio label="">无</radio>
                <radio label="1">1分钟</radio>
                <radio label="5">5分钟</radio>
                <radio label="10">10分钟</radio>
                <radio label="20">20分钟</radio>
                <radio label="30">30分钟</radio>
                <radio label="60">60分钟</radio>
              </radio-group>
          </form-item>
          <Tooltip content="自动刷新" placement="bottom">
            <i-switch v-model="monitorModal" style="margin-top: 5px" size="large" @on-change="controlMonitorTimer">
              <span slot="open">自动</span>
              <span slot="close">关闭</span>
            </i-switch>
          </Tooltip> -->
      <!--</i-col>-->
      <!--<i-col span="6">-->
            <!-- <Button type="primary" @click="getLogsDetail">搜索</Button>
            <Button @click="searchReset" style="margin-left: 10px;">重置</Button> -->
        <!-- <Button style="float: right;" @click="addIndex" type="primary" :style="{marginBottom: '10px'}">添加索引</Button> -->
      <!--</i-col>-->
      <!--</Row>
      <Row>-->
        <!--<i-col span="24">-->
          <!-- <FormItem label="显示条数" prop="size" :label-width="100" >
            <InputNumber :max="10000" :min="1" v-model="searchForm.size" class="mob-w-100"></InputNumber>
          </FormItem>
            <FormItem label="路径"  prop="module" :label-width="60"  >
               <Input v-model="searchForm.module" placeholder="日志文件绝对路径(可模糊匹配)" style="min-width: 300px" class="mob-w-100"/>
          </FormItem> -->
          <!-- <form-item label="项目" prop="category" :label-width="60">
            <i-select v-model="searchForm.category"  style="min-width: 80px">
                <Option value="baiyiqa">佰易</Option>
                <Option value="tomcat">运维平台</Option>
                <Option value="nginx">nginx</Option>
            </i-select>
        </form-item> -->
         <FormItem label="主机" prop="host" :label-width="60"  >
          <!-- <i-select v-model="searchForm.host" style="min-width: 450px" filterable clearable multiple>
            <i-option v-for="item in hostList" :value="item" :key="item" :label="item"></i-option>
          </i-select> -->
          <ServerTree ref="serverTree" :hosts="logHosts"/>
          </FormItem>
          <FormItem label="路径"  prop="module" :label-width="60">
               <Input v-model="searchForm.module" placeholder="日志文件绝对路径(可模糊匹配)" style="min-width: 300px" class="mob-w-100"/>
          </FormItem>
          <FormItem label="显示条数" prop="size" :label-width="100" style="margin-left: 5px;">
            <InputNumber :max="10000" :min="1" v-model="searchForm.size" class="mob-w-100"></InputNumber>
          </FormItem>
            <!-- <FormItem label="全文搜索" prop="key" :label-width="110">
              <Input v-model="searchForm.key" search enter-button="开始分析" @on-search="analyzeLog('searchForm')"  placeholder="输入过滤关键字" style="min-width: 530px" class="mob-w-100"/>
          </FormItem> -->
            <Button style="margin-left:5px;" type="info" @click="analyzeLog('searchForm')">开始分析</Button>
                        <Button style="margin-left:5px;" type="info" @click="showColConfig">显示列</Button>
         </Row>
         <Row>
        <!-- <Col :lg="24" style="margin-top: 8px">
        <Card shadow style="height: 500px" class="no-padding-card-body">
          <p slot="title">
            <span>日志路径统计报表</span>
          </p>
          <div>
            <Alert type="error" v-if="contentCost.error" show-icon style="margin: 16px;">获取数据失败</Alert>
            <Row :gutter="16" v-else>
              <Col :lg="24" style="margin-top: 8px">
                <div id="bre_mon_product_id" style="width: 100%; height: 450px;"></div>
              </Col>
            </Row>
          </div>
        </Card>
      </Col> -->
       <!-- <Col :lg="24" style="margin-top: 8px">
        <Card shadow style="height: 500px" class="no-padding-card-body">
          <p slot="title">
            <span>日志内容重复统计报表</span>
          </p>
          <div>
            <Alert type="error" v-if="contentCost.error" show-icon style="margin: 16px;">获取数据失败</Alert>
            <Row :gutter="16" v-else>
              <Col :lg="24" style="margin-top: 8px">
                <div id="bre_mon_content_id" style="width: 100%; height: 750px;"></div>
              </Col>
            </Row>
          </div>
        </Card>
      </Col> -->
      </Row>
    </Form>
     <Row>
        <Table
          ref="table"
          size="small"
          :columns="columns"
          :data="tableData"
          :loading="table_loading"
        ></Table>
      </Row>
      <Drawer
        title="添加索引"
        v-model="change"
        width="720"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="100" :rules="ruleValidate">
          <FormItem label="索引名称" prop="indexName">
            <i-input v-model="formItem.indexName" placeholder="请输入索引名称" style="width: 200px;"></i-input>
          </FormItem>
          <form-item>
           <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
           <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
    <!-- <Card :bordered="false">
      <Row style="margin: 1px;">
        <div style="float: center;background:#eee;padding: 2px;min-height:600px">
          <span v-html="logContent"/>
       </div>
     </Row>
    </Card> -->
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { reAnalyzeLogs, createIndex, deleteIndex, analyzeList, queryHosts, queryHostContentCount } from '@/api/log'
import { getOpsCenterAllServer } from '@/api/opscenter'
import { getModuleAllListLog } from '@/api/workflow/project'
// import moment from 'moment'
import NginxMonitor from './NginxMonitor'
import ServerTree from '@/view/components/server/server-tree'

export default {
  name: 'LogAnalyzeContent',
  components: {
    NginxMonitor,
    ServerTree
  },
  data () {
    return {
      productCost: {
        searchForm: {
          platformAndUsername: '',
          support: null,
          username: null
        },
        loading: false,
        error: false,
        barOption: {
          legend: {},
          tooltip: {
            trigger: 'axis',
            showContent: false
          },
          dataset: {
            source: [
            ]
          },
          xAxis: {type: 'category'},
          yAxis: {gridIndex: 0},
          grid: {top: '35%'},
          series: [
          ]
        }
      },
      contentCost: {
        searchForm: {
          platformAndUsername: '',
          support: null,
          username: null
        },
        loading: false,
        error: false,
        barOption: {
          backgroundColor: '#fff',
          grid: {
            left: 100,
            top: '20%',
            bottom: 60,
            right: 0
          },
          legend: {
            data: [],
            align: 'left',
            right: 0
            // textStyle: {
            //   color: '#434e79',
            //   fontSize: 14,
            //   fontWeight: 400
            // },
            // itemWidth: 14,
            // itemHeight: 10,
            // itemGap: 35
          },
          tooltip: {
            trigger: 'axis',
            padding: [8, 10],
            backgroundColor: 'rgba(0,0,0,0.5)',
            axisPointer: {
              type: 'shadow',
              textStyle: {
                color: '#fff'
              }
            }
          },
          xAxis: [{
            type: 'category',
            data: [],
            axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#434e79',
                fontSize: 16,
                fontWeight: 400
              }
            }
          }],
          yAxis: [{
            min: 0,
            type: 'value',
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0
            },
            splitArea: {
              show: false
            }
          }],
          series: []
        },
        pieOption: {
          title: {
            show: false
          },
          tooltip: {
            trigger: 'item',
            formatter: function (data, index) {
              let res = `<div class="circle_tooltip" style="background-color: ${data.color}"></div>` +
                `<span>${data.name}</span> : <span>${data.value}</span>(${data.percent}%)<br/>`

              return res
            }
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: [],
            show: false
          },
          series: [
            {
              name: '日志路径',
              type: 'pie',
              radius: '55%',
              center: ['50%', '60%'],
              data: [],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              label: {
                normal: {
                  formatter: function (data, index) {
                    return `${data.name}：${data.value}  {per|${data.percent}%}\n  `
                  },
                  rich: {
                    a: {
                      color: '#999',
                      lineHeight: 15,
                      align: 'center'
                    },
                    b: {
                      fontSize: 12
                    },
                    per: {
                      color: '#eee',
                      backgroundColor: '#334455',
                      padding: [2, 4],
                      borderRadius: 2
                    }
                  }
                }
              }
            }
          ]
        }
      },
      logHosts: [],
      status: null,
      ordering: null,
      dateDisabled: false,
      col: [],
      saveShowColConfiging: false,
      tableColModal: false,
      timer: null,
      monitorModal: false,
      moduleList: [],
      changeLoadingShow: false,
      change: false,
      logContent: '',
      indexList: [],
      hostList: [],
      searchForm: {
        host: [],
        module: '',
        logDate: null,
        size: 100,
        key: null,
        category: this.$store.state.user.defaultTenant,
        selectTime: ''
      },
      formItem: {
        indexName: null
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidSearch: {
        // host: [{ required: true, type: 'string', message: '主机名不能为空 !', trigger: 'change' }],
        // module: [{ required: true, type: 'string', message: '日志路径不能为空 !', trigger: 'blur' }],
        logDate: [{ required: true, type: 'array', message: '请选择查询时间', trigger: 'change' }],
        size: [{ required: true, type: 'number', message: '显示条数不能为空 !', trigger: 'blur' }]
      },
      ruleValidate: {
        // host: [{ required: true, message: '主机名不能为空 !', trigger: 'change' }],
        // logDate: [{ required: true, type: 'date', message: '请选择查询时间', trigger: 'change' }]
      },
      tableColumnList: {
        key: {
          minWidth: 700,
          title: '日志内容',
          align: 'left',
          key: 'key'
        },
        doc_count: {
          minWidth: 700,
          title: '出现次数',
          align: 'left',
          key: 'doc_count'
        }
        // timestamp: {
        //   minWidth: 50,
        //   title: '时间',
        //   align: 'left',
        //   key: 'timestamp',
        //   render: (h, params) => {
        //     if (params.row['@timestamp']) {
        //       return h('div', moment(params.row['@timestamp']).format('YYYY-MM-DD HH:mm:ss'))
        //     } else {
        //       return ''
        //     }
        //   }
        // },
        // host: {
        //   minWidth: 40,
        //   title: '主机',
        //   align: 'left',
        //   key: 'host',
        //   render: (h, params) => {
        //     if ('name' in params.row.host) {
        //       return h('div', params.row.host.name)
        //     } else {
        //       return ''
        //     }
        //   }
        // },
        // path: {
        //   minWidth: 30,
        //   title: '路径',
        //   align: 'left',
        //   key: 'path',
        //   render: (h, params) => {
        //     if ('path' in params.row.log.file) {
        //       return h('div', params.row.log.file.path)
        //     } else {
        //       return ''
        //     }
        //   }
        // }
      },
      columns: [],
      tableData: [],
      table_loading: false
    }
  },
  watch: {
    // '$store.state.user.defaultTenant' () {
    //   this.getModuleAllListLog()
    //   this.searchForm.category = this.$store.state.user.defaultTenant
    // }
  },
  beforeDestroy () {
    // clearInterval(this.timer)
    // this.timer = null
  },
  created () {
    // clearInterval(this.timer)
    // this.timer = null
    this.getShowCol()
  },
  methods: {
    // queryHostPathCount () {
    //   queryHostPathCount().then(res => {
    //     this.logHosts = res.data.data
    //   }).catch(res => {
    //     if (res.request) {
    //       this.$Notice.error({
    //         title: '获取日志列表失败！请求状态码:' + res.request.status,
    //         desc: res.request.responseText
    //       })
    //     }
    //   })
    // },
    getLogHosts () {
      this.logHosts = []
      queryHosts().then(res => {
        this.logHosts = res.data.data
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取日志列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    changeSort (column) {
      if (column.key === 'status') {
        if (column.order === 'asc') {
          this.ordering = 'status'
        } else {
          this.ordering = '-status'
        }
      }
      this.getLogsDetail()
    },
    lastTimeChange () {
      if (this.searchForm.selectTime) {
        this.dateDisabled = true
        this.monitorModal = true
      } else {
        this.monitorModal = false
        this.dateDisabled = false
      }
      this.controlMonitorTimer()
    },
    getShowCol () {
      this.col = ['key', 'doc_count']
      this.getTableColumns()
    },
    saveShowColConfig () {
      this.saveShowColConfiging = true
      this.getTableColumns()
      this.saveShowColConfiging = false
      this.tableColModal = false
    },
    getTableColumns () {
      let data = []
      this.col.forEach(col => data.push(this.tableColumnList[col]))
      data.sort(function (a, b) {
        return b.minWidth - a.minWidth
      })
      this.columns = data
    },
    showColConfig () {
      this.tableColModal = true
    },
    // 自动刷新
    setTimer () {
      // if (this.timer == null) {
      //   this.timer = setInterval(() => {
      //     this.getLogsDetail
      //   }, 5000)
      // }
    },
    // 定时刷新控制器
    controlMonitorTimer () {
      if (this.monitorModal) {
        this.setTimer()
      } else {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    getModuleAllListLog () {
      this.searchForm['module'] = ''
      getModuleAllListLog({ tenant_id__in: this.$store.state.user.defaultTenant }).then(res => {
        this.moduleList = res.data
      })
    },
    deleteIndex () {
      deleteIndex().then(res => {
      })
    },
    handleDateChange (value) {
    },
    // addIndex () {
    //   this.formItem.userId = null
    //   this.change = true
    // },
    getLogsDetail (value = 1) {
      this.table.page = value
      this.table_loading = true
      let params = {
        size: this.table.size,
        page: this.table.page,
        ordering: this.ordering,
        status: this.status
      }
      analyzeList(params).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.table_loading = false
      }).catch(res => {
        this.table_loading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取日志列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    analyzeLog (name) {
      this.table_loading = true
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.$refs.serverTree.server_obj && this.$refs.serverTree.server_obj.length === 1) {
            // let hostStr = this.searchForm['host']
            let beginTime = dayjs(this.searchForm.logDate[0]).format('YYYY-MM-DD HH:mm:ss')
            let endTime = dayjs(this.searchForm.logDate[1]).format('YYYY-MM-DD HH:mm:ss')
            let params = {
              host: this.$refs.serverTree.server_obj ? this.$refs.serverTree.server_obj.map(j => j.label).join(',') : '',
              beginTime: beginTime,
              endTime: endTime,
              module: this.searchForm.module,
              size: this.searchForm.size
            }
            queryHostContentCount(params).then(res => {
              this.tableData = res.data.data
              this.table_loading = false
            }).catch(res => {
              this.table_loading = false
              console.error(res)
            })
          } else {
            this.$Notice.error({
              title: '请选择一台主机进行分析'
            })
          }
        }
      })
    },
    reAnalyzeLogs (id) {
      let params = {
        id: id
      }
      reAnalyzeLogs(params).then(res => {
        this.getLogsDetail()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取日志列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    drawerClose () {
      let that = this.formItem
      that.index_name = ''
    },
    searchReset () {
      // this.searchForm.name = null
    },
    // getAllIndex () {
    //   getAllIndex().then(res => {
    //     this.indexList = res.data
    //   })
    // },
    onSelectIndex (value) {
    },
    onSelectCategory (value) {
    },
    initData () {
      this.searchForm.logDate = [new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000), new Date()]
      this.getAssetOptions()
      this.getLogHosts()
      // this.queryHostPathCount()
    },
    getAssetOptions () {
      getOpsCenterAllServer().then(res => {
        this.hostList = res.data.map(item => item.hostname)
      })
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          createIndex(params).then(res => {
            if (res.data.code === 200) {
              this.$Message.success('添加成功')
            }
          })
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    }
  },
  mounted: function () {
    this.initData()
    // this.getModuleAllListLog()
    this.getLogsDetail()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
<style lang="less">
.mob-d-t{
  .ivu-form-item-content{
    display: table;
    margin-left: 0!important;
    float: right;
  }
}
.log-query{
  .vue-treeselect__control{
    width:initial;
    min-width: 330px;
  }
  .vue-treeselect__multi-value-item-container {
      padding-top: 1px;
      height: 30px;
  }
  .vue-treeselect__multi-value-item{
    height: 96%;
  }
  .vue-treeselect__multi-value-item{
    line-height: 1;
  }
  .vue-treeselect--has-value .vue-treeselect__multi-value {
    margin-bottom: 0px;
  }
  .vue-treeselect__control{
    height: 32px;
  }
  .ivu-form-item-content{
    line-height: 30px;
  }
  .vue-treeselect__x-container{
    position: relative;
    right: 8px;
  }
}
</style>
